// $(".continuous-timer-main").length > 0) {
//    var countDownHours = parseInt(document.getElementById("continuous_timer").getAttribute("sale_countdown_time_hours")),
//       countDownMinutes = parseInt(document.getElementById("continuous_timer").getAttribute("sale_countdown_time_minutes")),
//       countDownDuration = countDownHours * 60 * 60 * 1e3 + countDownMinutes * 60 * 1e3,
//       storedStartTime = localStorage.getItem("startTime"),
//       startTime;
//    storedStartTime ? startTime = parseInt(storedStartTime, 10) : (startTime = new Date().getTime(), localStorage.setItem("startTime", startTime));
//    var x = setInterval(function () {
//       var now = new Date().getTime(),
//          elapsed = now - startTime,
//          distance = countDownDuration - elapsed % countDownDuration,
//          hours = Math.floor(distance % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)),
//          minutes = Math.floor(distance % (1e3 * 60 * 60) / (1e3 * 60)),
//          seconds = Math.floor(distance % (1e3 * 60) / 1e3),
//          display = "";
//       hours > 0 && (display += `  <span>${hours}h</span>`), display += `  <span>${minutes}m</span>  <span>${seconds}s</span>`, document.getElementById("continuous_timer").innerHTML = display, distance <= 0 && (startTime = new Date().getTime(), localStorage.setItem("startTime", startTime))
//    }, 1e3)
// }


setTimeout(function() {
    $('.featured--collection_tabing-content').hide();
    $('.featured--collection_tabing-content:first').show();
}, 2500);
$('.featured--collection_tabing--header_item---link').click(function(e){
  e.preventDefault();
  $('.featured--collection_tabing--header_item---link').removeClass('active');
  $(this).addClass('active');
  $('.featured--collection_tabing-content').hide();
  
  var activeTab = $(this).attr('href');
  $(activeTab).fadeIn();
  return false;
});


/**
 * FREE GIFT AUTO ADD/REMOVE
 * - Adds free gift when cart quantity (excluding gift) >= 4
 * - Removes free gift when cart quantity (excluding gift) < 4
 *
 * FIX: Uses /cart/update.js with variant ID (not line index) to avoid
 * accidentally removing the wrong line when indices shift during updates.
 */

const FREE_GIFT_VARIANT_ID = 49801130442991;
const FREE_GIFT_THRESHOLD = 3;

// (function () {

//   // ── guard: only one sync running at a time ─────────────────────────────────
//   let _syncing = false;

//   // ── helpers ────────────────────────────────────────────────────────────────

//   function postJSON(url, data) {
//     return fetch(url, {
//       method: "POST",
//       headers: { "Content-Type": "application/json", Accept: "application/json" },
//       body: JSON.stringify(data),
//     }).then((r) => r.json());
//   }

//   /** Show/hide the cart-drawer loading overlay (reuses the theme's AnimateLoading) */
//   function setCartLoading(active) {
//     const drawerInner = document.querySelector(".m-cart-drawer__inner");
//     if (!drawerInner) return;
//     if (window.MinimogLibs && window.MinimogLibs.AnimateLoading) {
//       if (!window._freeGiftLoader) {
//         window._freeGiftLoader = new window.MinimogLibs.AnimateLoading(drawerInner, {
//           overlay: drawerInner,
//         });
//       }
//       active ? window._freeGiftLoader.start() : window._freeGiftLoader.finish();
//     }
//   }

//   /**
//    * Fetch live cart and return state.
//    * qualifyingQty = total cart qty EXCLUDING the free gift itself.
//    */
//   async function getCartState() {
//     const cart = await fetch("/cart.js").then((r) => r.json());

//     let qualifyingQty = 0;
//     let giftInCart    = false;
//     let giftLineKey   = null;   // use Shopify line key (stable, not index)

//     cart.items.forEach((item) => {
//       if (Number(item.variant_id) === FREE_GIFT_VARIANT_ID) {
//         giftInCart  = true;
//         giftLineKey = item.key;  // "variant_id:hash" – stays valid even after other lines shift
//       } else {
//         qualifyingQty += item.quantity;
//       }
//     });

//     return { qualifyingQty, giftInCart, giftLineKey };
//   }

//   /** Add the free gift */
//   async function addFreeGift() {
//     await postJSON(`${window.Shopify.routes.root}cart/add.js`, {
//       items: [{ id: FREE_GIFT_VARIANT_ID, quantity: 1 }],
//     });
//   }

//   /**
//    * Remove the free gift using its LINE KEY (not index).
//    * /cart/update.js accepts { updates: { "key": 0 } } – only touches that key.
//    */
//   async function removeFreeGift(lineKey) {
//     await postJSON(`${window.Shopify.routes.root}cart/update.js`, {
//       updates: { [lineKey]: 0 },
//     });
//   }

//   /** Re-render the cart drawer panels exactly like the theme does */
//   async function refreshCartSections() {
//     const sectionName  = "cart-drawer";
//     const countSection = "cart-count";

//     const url  = `${window.Shopify.routes.root}?sections[]=${sectionName}&sections[]=${countSection}`;
//     const data = await fetch(url).then((r) => r.json());

//     // Redraw each panel
//     [
//       { id: "MinimogCartDrawer", sel: "#MinimogCartDrawerHeader" },
//       { id: "MinimogCartDrawer", sel: "#MinimogCartDrawerBody"   },
//       { id: "MinimogCartDrawer", sel: "#MinimogCartDrawerFooter" },
//     ].forEach(({ id, sel }) => {
//       const root   = document.getElementById(id);
//       const target = root && root.querySelector(sel);
//       if (!target || !data[sectionName]) return;
//       const parsed = new DOMParser().parseFromString(data[sectionName], "text/html");
//       const source = parsed.querySelector(sel);
//       if (source) target.innerHTML = source.innerHTML;
//     });

//     // Update cart-count badges
//     const cartCounts = document.querySelectorAll("m-cart-count");
//     if (data[countSection] && cartCounts.length) {
//       const newDoc = new DOMParser().parseFromString(data[countSection], "text/html");
//       cartCounts.forEach((el) => el.onUpdate && el.onUpdate(newDoc));
//     }

//     // Emit theme's own pubSub so savings bars / FoxKit update
//     if (window.MinimogEvents && window.MinimogTheme) {
//       const freshCart      = await fetch("/cart.js").then((r) => r.json());
//       freshCart.sections   = data;
//       window.MinimogEvents.emit(
//         window.MinimogTheme.pubSubEvents.cartUpdate,
//         { cart: freshCart }
//       );
//     }
//   }

//   // ── core sync ──────────────────────────────────────────────────────────────

//   async function syncFreeGift() {
//     // Prevent multiple simultaneous syncs
//     if (_syncing) return;
//     _syncing = true;

//     try {
//       const { qualifyingQty, giftInCart, giftLineKey } = await getCartState();
//       const shouldHaveGift = qualifyingQty >= FREE_GIFT_THRESHOLD;

//       // Already in the correct state — nothing to do
//       if (shouldHaveGift === giftInCart) return;

//       setCartLoading(true);

//       if (shouldHaveGift && !giftInCart) {
//         await addFreeGift();
//       } else if (!shouldHaveGift && giftInCart) {
//         // Use line KEY so index-shifting never touches the wrong item
//         await removeFreeGift(giftLineKey);
//       }

//       await refreshCartSections();

//     } catch (err) {
//       console.error("[FreeGift] sync error:", err);
//     } finally {
//       setCartLoading(false);
//       _syncing = false;
//     }
//   }

//   // ── event hooks ────────────────────────────────────────────────────────────

//   function attachListeners() {
//     // Fired by the theme after every quantity change or remove (MCartItems)
//     document.addEventListener("cart:updated", () => syncFreeGift());

//     // Fired after add-to-cart flows
//     document.addEventListener("cart:refresh", () => syncFreeGift());

//     // On page load (hard refresh / direct visit)
//     if (document.readyState === "loading") {
//       document.addEventListener("DOMContentLoaded", () => syncFreeGift());
//     } else {
//       syncFreeGift();
//     }
//   }

//   function attachPubSub() {
//     if (window.MinimogEvents && window.MinimogTheme) {
//       window.MinimogEvents.subscribe(
//         window.MinimogTheme.pubSubEvents.cartUpdate,
//         () => syncFreeGift()
//       );
//     }
//   }

//   // Boot — wait for theme globals if needed
//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", () => {
//       attachListeners();
//       attachPubSub();
//     });
//   } else {
//     attachListeners();
//     attachPubSub();
//   }

// })();



/**
 * sales-points-inventory.js
 * ------------------------------------------------------------------
 * Keeps the low-inventory sales point ("Hurry, only a few left!")
 * in sync when the customer changes a variant.
 *
 * Why this is needed:
 *   product-info.js only re-renders Price / Inventory / Sku /
 *   Availability / Volume / PricePerItem on a variant change. The
 *   #sales-points <ul> is NOT in that list, so it keeps showing the
 *   value rendered for the first variant.
 *
 * How it works:
 *   On every variant change the theme emits `variantChange` with the
 *   freshly fetched section HTML. That HTML already contains a correct
 *   #sales-points (your {% if inventory_quantity < 10 %} runs per
 *   variant server-side), so we just copy it into the live DOM.
 *
 * No changes to product-info.js are required. Just load this file.
 * ------------------------------------------------------------------
 */
(function () {
  'use strict';

  var SALES_POINTS_SELECTOR = '#sales-points, .sales-points';

  /**
   * Find the live <product-info> that fired the event so we update the
   * right one (handles main product + quick view without touching others).
   */
  function findProductInfo(sectionId) {
    return (
      document.querySelector('product-info[data-original-section="' + sectionId + '"]') ||
      document.querySelector('product-info[data-section-id="' + sectionId + '"]') ||
      document.querySelector('product-info')
    );
  }

  /**
   * Primary path: replace the live sales-points with the server-rendered
   * one from the fetched variant HTML. Returns true on success.
   */
  function updateFromHtml(productInfo, html) {
    if (!html || typeof html.querySelector !== 'function') return false;

    var source = html.querySelector(SALES_POINTS_SELECTOR);
    var destination = productInfo.querySelector(SALES_POINTS_SELECTOR);
    if (!source || !destination) return false;

    // Copy the server-rendered markup (the <li> is present only when
    // inventory_quantity < threshold, so this both shows AND hides it).
    destination.innerHTML = source.innerHTML;
    return true;
  }

  /**
   * Fallback path: no usable HTML, so use the variant JSON directly.
   * Only works if the theme exposes `inventory_quantity` on the variant
   * object — if it doesn't, we leave the current markup untouched rather
   * than risk hiding a valid message.
   */
  function updateFromVariant(productInfo, variant) {
    if (!variant) return;

    var destination = productInfo.querySelector(SALES_POINTS_SELECTOR);
    if (!destination) return;

    var marker = destination.querySelector('[data-product-inventory]');
    var threshold = marker ? parseInt(marker.getAttribute('data-threshold'), 10) : 10;
    if (isNaN(threshold)) threshold = 10;

    var qty = variant.inventory_quantity;
    if (typeof qty !== 'number') return; // can't tell — leave as is

    var existingItem = destination.querySelector('.sales-point');
    var shouldShow = variant.available !== false && qty > 0 && qty < threshold;

    if (shouldShow && !existingItem) {
      destination.innerHTML =
        '<li class="sales-point">' +
        '<span class="icon-and-texts inventory--low"></span>' +
        '<span class="icon-and-text inventory--low">' +
        '<span class="icon icon--inventory"></span>' +
        '<span data-product-inventory="" data-threshold="' + threshold + '" data-enabled="true">' +
        'Hurry, only a few left!' +
        '</span></span></li>';
    } else if (!shouldShow && existingItem) {
      destination.innerHTML = '';
    }
  }

  function handleVariantChange(payload) {
    // pub/sub payload shape: { data: { variant, sectionId, html } }
    var data = (payload && payload.data) || {};
    var productInfo = findProductInfo(data.sectionId);
    if (!productInfo) return;

    if (!updateFromHtml(productInfo, data.html)) {
      updateFromVariant(productInfo, data.variant);
    }
  }

  /**
   * The theme exposes MinimogEvents / MinimogTheme as globals, but this
   * file may load before they exist. Poll briefly, then subscribe.
   */
  function subscribe() {
    if (
      window.MinimogEvents &&
      window.MinimogTheme &&
      window.MinimogTheme.pubSubEvents &&
      window.MinimogTheme.pubSubEvents.variantChange
    ) {
      window.MinimogEvents.subscribe(
        window.MinimogTheme.pubSubEvents.variantChange,
        handleVariantChange
      );
      return true;
    }
    return false;
  }

  if (!subscribe()) {
    var tries = 0;
    var timer = setInterval(function () {
      if (subscribe() || ++tries > 50) clearInterval(timer); // ~5s max
    }, 100);
  }
})();
// =============================================
